const DEFAULT_PLATFORM_URL = 'https://cispracs.ru';

function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getPlatformUrl(): string {
  const configured = import.meta.env.VITE_PLATFORM_URL?.trim();
  return trimTrailingSlashes(configured || DEFAULT_PLATFORM_URL);
}

/**
 * A team's public page on cispracs.ru. The team tag Bunker receives from the
 * platform IS the team's slug (POLE → cispracs.ru/t/POLE), so no lookup is
 * needed.
 */
export function buildTeamProfileUrl(tag: string, platformUrl = getPlatformUrl()): string {
  return `${trimTrailingSlashes(platformUrl)}/t/${encodeURIComponent(tag)}`;
}

export function buildPublicInviteUrl(code: string, platformUrl = getPlatformUrl()): string {
  return `${trimTrailingSlashes(platformUrl)}/invite/${encodeURIComponent(code)}`;
}

/**
 * Public profile link — the `/u/<name>` landing page (PublicProfilePage),
 * which is served by this very SPA. Defaults the base to wherever the app
 * is hosted (`window.location.origin`) so the QR resolves correctly in any
 * environment; the mobile client mirrors this against its hardcoded API_URL.
 */
export function buildPublicProfileUrl(
  username: string,
  origin = window.location.origin,
): string {
  return `${trimTrailingSlashes(origin)}/u/${encodeURIComponent(username)}`;
}
